import { signal } from '@angular/core';
import { TwcLegendParams } from '../../../twc-legend/twc-legend.params';
import { TwcLegendComponent } from '../../../twc-legend/twc-legend.component';
import { LightningSvgComponent } from './lightning-svg/lightning-legend-svg';

export const LIGHTNING_LEGEND: TwcLegendParams = {
  title: 'LIGHTNING',
  legendTitleBarInfo: signal('0'),
  data: { svgComponent: LightningSvgComponent },
  legendComponent: TwcLegendComponent
};
